import { gql } from '@provision/graphql-client';

export const META_DATA_QUERY_FIELDS = gql`
  fragment MetaDataQueryFields on MetaData {
    totalRecords @skip(if: $skipTotalRecords)
    offset
    appVersion
    forceAppVersion
  }
`;

export const META_DATA_SEARCH_QUERY_FIELDS = gql`
  fragment MetaDataSearchQueryFields on MetaDataWithSearch {
    totalRecords @skip(if: $skipTotalRecords)
    offset
    appVersion
    forceAppVersion
  }
`;
